<app-attendee-layout>
  <h1 class="onebooking__title">
    {{ 'attendee.onebooking.workshop-appointment' | translate }}
  </h1>
  <iframe
    class="onebooking__widget"
    [src]="oneBookingUrl | safeUrl"
    allowfullscreen
    title="booking widget"
  ></iframe>
</app-attendee-layout>
